module.exports = __webpack_public_path__ + "static/media/service_body_04.688998ad.webp";